var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgR2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 113,
    height: 112,
    viewBox: "0 0 113 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.666504,
    width: 112,
    height: 112,
    rx: 16,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M74.6665 64H68.6665C67.6056 64 66.5882 64.4214 65.8381 65.1716C65.0879 65.9217 64.6665 66.9391 64.6665 68V74M74.6665 74V74.02M56.6665 46V52C56.6665 53.0609 56.2451 54.0783 55.4949 54.8284C54.7448 55.5786 53.7274 56 52.6665 56H46.6665M38.6665 56H38.6865M56.6665 38H56.6865M56.6665 64V64.02M64.6665 56H66.6665M74.6665 56V56.02M56.6665 74V72M40.6665 38H46.6665C47.7711 38 48.6665 38.8954 48.6665 40V46C48.6665 47.1046 47.7711 48 46.6665 48H40.6665C39.5619 48 38.6665 47.1046 38.6665 46V40C38.6665 38.8954 39.5619 38 40.6665 38ZM66.6665 38H72.6665C73.7711 38 74.6665 38.8954 74.6665 40V46C74.6665 47.1046 73.7711 48 72.6665 48H66.6665C65.5619 48 64.6665 47.1046 64.6665 46V40C64.6665 38.8954 65.5619 38 66.6665 38ZM40.6665 64H46.6665C47.7711 64 48.6665 64.8954 48.6665 66V72C48.6665 73.1046 47.7711 74 46.6665 74H40.6665C39.5619 74 38.6665 73.1046 38.6665 72V66C38.6665 64.8954 39.5619 64 40.6665 64Z",
    stroke: "#0034A3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgR2);
export default __webpack_public_path__ + "static/media/r2.6bf3015b2df6380d322c3c494e207fb6.svg";
export { ForwardRef as ReactComponent };